// src/components/Approach.jsx

import React from "react";
import "./Approach.css"; // Importa o novo CSS
import approachImage from "../assets/approach.png"; // Importa a imagem da estátua
import backImage from "../assets/bg.svg"; // Importa a imagem da estátua
import { Slide, Fade, Zoom } from "react-awesome-reveal";

// Dados dos passos para renderização dinâmica
const approachData = [
  {
    number: "1",
    title: "Descoberta & Avaliação",
    description:
      "Identificamos gargalos e riscos. Entregamos um plano imediato com ganhos rápidos.",
  },
  {
    number: "2",
    title: "Arquitetura & Plano",
    description:
      "Criamos soluções seguras e escaláveis, reduzindo custos e incidentes desde o primeiro dia.",
  },
  {
    number: "3",
    title: "Implementação & Hardening",
    description:
      "Mudanças seguras, com resultados mensuráveis e comparativos claros.",
  },
  {
    number: "4",
    title: "Observabilidade & Operação Contínua",
    description:
      "Monitoramento 24×7, auditoria ativa e melhorias contínuas. Problema resolvido para sempre.",
  },
];

const Approach = () => {
  return (
    <section
      id="approach"
      className="approach-section"
      style={{
        backgroundImage: `url(${backImage})`,
      }}
    >
      <div className="approach-grid">
        <Slide direction="left" triggerOnce>
          <div className="approach-image">
            <img
              src={approachImage}
              className="approach-image"
              alt="Nosso Processo"
            ></img>
          </div>
        </Slide>

        <Slide direction="right" triggerOnce>
          <div className="approach-content">
            <h2 className="approach-title">
              Nosso <span className="highlight">Processo</span>
            </h2>
            <div className="approach-steps-list">
              {approachData.map((step, index) => (
                // 👇 4. ANIMAÇÃO INDIVIDUAL EM CADA PASSO
                <Fade key={step.number} delay={index * 150} triggerOnce>
                  <div className="approach-step-item">
                    <div className="step-number">{step.number}</div>
                    <div className="step-text">
                      <h3>{step.title}</h3>
                      <p>{step.description}</p>
                    </div>
                  </div>
                </Fade>
              ))}

              {/* <Zoom delay={500} triggerOnce>
                <center>
                  <a href="#contacts" className="services-button">
                    Quero meu Diagnóstico Gratuito
                  </a>
                </center>
              </Zoom> */}
            </div>
          </div>
        </Slide>
      </div>

      <div className="approach-cta">
        <Zoom delay={500} triggerOnce>
          <a href="#contacts" className="services-button">
            Quero meu Diagnóstico Gratuito
          </a>
        </Zoom>
      </div>
    </section>
  );
};

export default Approach;
